export function SpeechBubbleEditIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_24_230)">
        <path
          d="M8.1875 12.3344C8.73894 12.3344 9.18555 12.781 9.18555 13.3324C9.18555 13.8838 8.73894 14.3304 8.1875 14.3304H5.49219C4.94075 14.3304 4.49414 13.8838 4.49414 13.3324C4.49414 12.781 4.94075 12.3344 5.49219 12.3344H8.1875Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          d="M8.1875 8.7406C8.73894 8.7406 9.18555 9.18721 9.18555 9.73865C9.18555 10.2901 8.73894 10.7367 8.1875 10.7367H5.49219C4.94075 10.7367 4.49414 10.2901 4.49414 9.73865C4.49414 9.18721 4.94075 8.7406 5.49219 8.7406H8.1875Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          d="M19.6191 2.46777C20.6964 1.65673 22.2881 1.71482 23.292 2.6416L23.4814 2.83496C24.3064 3.76901 24.3063 5.11781 23.4814 6.05176L23.292 6.24512L16.8369 12.2051C15.5126 13.4277 13.7525 14.0996 11.8828 14.0996C11.3479 14.0996 10.9006 13.698 10.9004 13.1855C10.9004 11.4524 11.6315 9.82349 12.9561 8.60059L19.4111 2.6416L19.6191 2.46777ZM21.9072 3.94043C21.6206 3.67612 21.1624 3.65923 20.8545 3.89062L20.7949 3.94043L14.3398 9.90039C13.6575 10.5304 13.199 11.3087 12.9922 12.1543C13.9173 11.9638 14.7666 11.539 15.4521 10.9062L21.9072 4.94629L21.9609 4.8916C22.192 4.63034 22.192 4.25628 21.9609 3.99512L21.9072 3.94043Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          d="M13.3955 3.10962C13.9594 3.10962 14.4219 3.55466 14.4219 4.10962C14.4217 4.66439 13.9593 5.10962 13.3955 5.10962H5.62988C4.15075 5.10962 2.95215 6.27834 2.95215 7.70923V18.509C2.95215 18.9473 3.31952 19.3086 3.77734 19.3088C3.98165 19.3088 4.1777 19.2363 4.3291 19.1047L5.87305 17.7629L5.94531 17.7053C6.12145 17.5783 6.3354 17.509 6.55566 17.509H16.3701C17.8492 17.509 19.0477 16.3402 19.0479 14.9094V12.8909C19.0479 12.3359 19.5103 11.8909 20.0742 11.8909C20.6381 11.8909 21.0996 12.336 21.0996 12.8909V14.9094C21.0995 17.4485 18.9754 19.509 16.3701 19.509H6.94629L5.69531 20.5979C5.16696 21.0571 4.48519 21.3088 3.77734 21.3088C2.19334 21.3086 0.900391 20.0556 0.900391 18.509V7.70923C0.900391 5.17004 3.02453 3.10962 5.62988 3.10962H13.3955Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_24_230">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
